import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
/** Common Components */
import FormCreator from "../../../components/finalForms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
/** Common Services & Data Files */
import { statusCategoryFormData } from "../config/statusCategories.data";
import {
  useAddStatusCategoryMutation,
  useUpdateStatusCategoryMutation,
} from "../../../app/services/statusCategoryAPI";
import ToastService from "../../../services/toastService/ToastService";

export const AddEditStatusCategory = (props) => {
  const [statusCategoryForm, setStatusCategoryForm] = useState(statusCategoryFormData);
  const statusCategoryRef = useRef();

  const [
    addStatusCategory,
    {
      isSuccess: isStatusCategoryAdded,
      isLoading: isStatusCategoryAdding,
      data: addStatusCategoryData,
    },
  ] = useAddStatusCategoryMutation();

  const [
    updateStatusCategory,
    {
      isLoading: isStatusCategoryUpdating,
      isSuccess: isStatusCategorySuccess,
      data: isStatusCategoryUpdateData,
    },
  ] = useUpdateStatusCategoryMutation();

  useEffect(() => {
    if (props.isEdit && props.statusCategoryData) {
      const formData = { ...statusCategoryFormData };
      formData.initialState = {
        statusCategoryName: props.statusCategoryData.statusCategoryName,
        isActive: props.statusCategoryData.isActive,
        sortOrder: props.statusCategoryData.sortOrder ?? "",
        isTerminal: props.statusCategoryData.isTerminal,
        isCompleted: props.statusCategoryData.isCompleted,
      };
      setStatusCategoryForm(formData);
    } else {
      formReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.statusCategoryData]);

  useEffect(() => {
    if (isStatusCategoryAdded && addStatusCategoryData) {
      if (addStatusCategoryData.errorMessage?.toLowerCase().includes("exists") ||
          addStatusCategoryData.errorMessage?.toLowerCase().includes("required") ||
          addStatusCategoryData.keyValue === 0) {
        ToastService.warning(addStatusCategoryData.errorMessage);
      } else {
        ToastService.success(addStatusCategoryData.errorMessage);
        props.onSuccess?.();
        backToList();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStatusCategoryAdded, addStatusCategoryData]);

  useEffect(() => {
    if (isStatusCategorySuccess && isStatusCategoryUpdateData) {
      if (isStatusCategoryUpdateData.errorMessage?.toLowerCase().includes("exists") ||
          isStatusCategoryUpdateData.errorMessage?.toLowerCase().includes("required") ||
          isStatusCategoryUpdateData.errorMessage?.toLowerCase().includes("no record") ||
          isStatusCategoryUpdateData.keyValue === 0) {
        ToastService.warning(isStatusCategoryUpdateData.errorMessage);
      } else {
        ToastService.success(isStatusCategoryUpdateData.errorMessage);
        props.onSuccess?.();
        backToList();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStatusCategorySuccess, isStatusCategoryUpdateData]);

  const formReset = () => {
    const form = { ...statusCategoryFormData };
    form.initialState = { ...statusCategoryFormData.initialState };
    setStatusCategoryForm(form);
  };

  const handleSubmit = () => {
    const formValues = statusCategoryRef.current.getFormData();
    if (formValues) {
      const sortOrderValue =
        formValues.sortOrder === "" || formValues.sortOrder === null || formValues.sortOrder === undefined
          ? null
          : Number(formValues.sortOrder);

      const requestData = {
        statusCategoryId: props.isEdit ? props.statusCategoryData.statusCategoryId : 0,
        statusCategoryName: formValues.statusCategoryName.trim(),
        isActive: formValues.isActive || false,
        sortOrder: Number.isNaN(sortOrderValue) ? null : sortOrderValue,
        isTerminal: formValues.isTerminal || false,
        isCompleted: formValues.isCompleted || false,
      };

      if (props.isEdit) {
        updateStatusCategory(requestData);
      } else {
        addStatusCategory(requestData);
      }
    }
  };

  const backToList = () => {
    props.onClose();
    formReset();
  };

  return (
    <>
      <FormCreator config={statusCategoryForm} ref={statusCategoryRef} />
      <div className="form-btn d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          imagePath={AppIcons.AddIcon}
          buttonText={`${props.isEdit ? "Update" : "Add"}`}
          onClick={handleSubmit}
          isLoading={isStatusCategoryAdding || isStatusCategoryUpdating}
        />
      </div>
    </>
  );
};

AddEditStatusCategory.propTypes = {
  statusCategoryData: PropTypes.object,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
  onSuccess: PropTypes.func,
};

export default AddEditStatusCategory;
